import React from "react";
import Auth from "../helpers/auth";

const UserDeveloperCompareInfo = ({user, otherUser}) => {
    
    const auth = Auth.getCompareAll(user, otherUser);
    console.log({user, otherUser, auth})
    const children = Object.entries(auth).map(e => {
        const txt = e[1] ? `${e[0]}, `: '';
        const className = `text-${e[1] ? "dark":"secondary"}`
        return <span className={className}>{txt}</span>
    });
   
    return(
        <h6>{`Compare: `} 
            <span>
                {children.map((c,idx) => <span key={idx}>{c}</span>)}
            </span>
        </h6>
    )
};
export default UserDeveloperCompareInfo;